import { FC, useCallback, useEffect, useState } from "react";
import { BusinessElementDependencyType, BusinessElementGameDependencyType, IBusinessElementDependency, setElementUpgradeState } from "../../../../../../redux/businesses";
import { trueInvitedFriendsForm } from "../../../../../../utils/true.word.form";
import { useDispatch, useSelector } from "../../../../../../hooks";
import styles from "./BusinessElementDependency.module.scss";

interface IBusinessElementDependencyProps extends IBusinessElementDependency {
    elementType: number;
};

export const BusinessElementDependency: FC<IBusinessElementDependencyProps> = ({ reqType, type, value, elementType }) => {
    const [isSuited, setIsSuited] = useState<boolean | undefined>();
    const [elementsLevelsSum, setElementsLevelsSum] = useState(0);

    const business = useSelector(store => store.businesses.activeBusiness);
    const referalsCount = useSelector(store => store.referals?.items?.length ?? 0);

    const dispatch = useDispatch();

    const findDependencyElement = useCallback(() => {
        return business && business.elements.find(element => element.type === type);
    }, [business, type]);

    const isElementSuited = useCallback(() => {
        return (findDependencyElement()?.level ?? 0) >= value
    }, [findDependencyElement, value]);

    const isGameFactorSuited = useCallback(() => {
        return referalsCount >= value;
    }, [value, referalsCount]);

    const getSuited = useCallback(() => {
        let suited = false;
        switch (reqType) {
            case BusinessElementDependencyType.Element: suited = isElementSuited(); break;
            case BusinessElementDependencyType.Game: suited = isGameFactorSuited(); break;
        }

        dispatch(setElementUpgradeState({
            type: elementType,
            state: suited,
        }));

        return suited;
    }, [dispatch, elementType, isElementSuited, isGameFactorSuited, reqType]);

    useEffect(() => {
        if (!business)
            return;

        setElementsLevelsSum(business.elements.reduce((acc, el) => acc + el.level, 0));
    }, [business]);

    useEffect(() => {
        setIsSuited(getSuited());
    }, [elementsLevelsSum, referalsCount, getSuited]);

    if (!business)
        return <></>;

    const getGameFactorDepName = () => {
        switch (type) {
            case BusinessElementGameDependencyType.Referal: return trueInvitedFriendsForm(value);
        }
    }

    const getElementDepName = () => findDependencyElement()?.name;

    const getDependency = () => {
        switch (reqType) {
            case BusinessElementDependencyType.Element: return `${getElementDepName()} ${value} ур.`;
            case BusinessElementDependencyType.Game: return `${value} ${getGameFactorDepName()}`;
        }
    }

    return (
        <>
            { !isSuited &&
                <span className={styles.text}>
                    { getDependency() }
                </span>
            }
        </>
    );
}